export default __webpack_public_path__ + "static/media/admin-logo-green.f0707d97.png";